module.exports = __webpack_public_path__ + "img/about2.5893685b.png";